var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_389_178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.15 5.23096L3.342 23.2763C3.11919 23.6621 3.00129 24.0996 3.00001 24.5451C2.99873 24.9907 3.11413 25.4288 3.33472 25.8159C3.55532 26.2031 3.87342 26.5257 4.25738 26.7517C4.64135 26.9777 5.0778 27.0993 5.52333 27.1043H27.142C27.5873 27.0992 28.0236 26.9776 28.4073 26.7516C28.7911 26.5257 29.1091 26.2032 29.3296 25.8163C29.5502 25.4294 29.6657 24.9915 29.6646 24.5461C29.6634 24.1008 29.5458 23.6634 29.3233 23.2776L18.5153 5.22963C18.2879 4.8543 17.9676 4.54395 17.5853 4.32856C17.2029 4.11316 16.7715 4 16.3327 4C15.8938 4 15.4624 4.11316 15.0801 4.32856C14.6977 4.54395 14.3774 4.8543 14.15 5.22963V5.23096Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12H16.0133",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.666 16H15.9993V21.3333H17.3327",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_389_178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrors);
export default __webpack_public_path__ + "static/media/errors.22acd6eb6b50e4f69a77ef2f71acccc5.svg";
export { ForwardRef as ReactComponent };